import { useState, useEffect } from 'react';

/**
 * lot DD — vrai sous 768 px (seuil `md:` de Tailwind), via `matchMedia`.
 * Sert à ne monter QU'UN des deux rendus (téléphone / ordinateur) d'un écran.
 */
export function useTelephone(seuil = 767) {
  const requete = `(max-width: ${seuil}px)`;
  const [telephone, setTelephone] = useState(
    () => (typeof window !== 'undefined' ? window.matchMedia(requete).matches : false),
  );

  useEffect(() => {
    const mql = window.matchMedia(requete);
    const onChange = (e) => setTelephone(e.matches);
    setTelephone(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [requete]);

  return telephone;
}

export default useTelephone;
